import React from 'react';
import { Dropdown } from '../../components/FormComponents';

// First Step Component
export const ServiceStep = ({ 
  serviceOptions, 
  selectedService, 
  handleServiceChange, 
  handleNextStep 
}) => {
  return (
    <div className="user-page__step-container">
      <h2 className="user-page__form-title">What services are you looking for?</h2>
      <div className="user-page__form-row">
        <Dropdown 
          options={serviceOptions} 
          placeholder="Select a service"
          value={selectedService}
          onChange={handleServiceChange}
          onArrowClick={handleNextStep}
          className="user-page__dropdown"
          allowCustomInput={false}
          isClearable={true}
        />
      </div>
    </div>
  );
};

// Second Step Component
export const AreaStep = ({
  areaOptions,
  selectedArea,
  handleAreaChange,
  handleNextStep,
  showSecondStep
}) => {
  return (
    <div className={`user-page__form-step-2 ${showSecondStep ? 'second-step-animate' : ''}`}>
      <h2 className="user-page__form-title">Which area are you looking in?</h2>
      <div className="user-page__form-row">
        <Dropdown 
          options={areaOptions} 
          placeholder="Select an area"
          value={selectedArea}
          onChange={handleAreaChange}
          onArrowClick={handleNextStep}
          className="user-page__dropdown"
          allowCustomInput={false}
          isClearable={true}
        />
      </div>
    </div>
  );
};

// Third Step Component
export const BudgetStep = ({
  selectedBudget,
  setSelectedBudget,
  dropdownExpanded,
  setDropdownExpanded,
  showThirdStep,
  setHasUserInput
}) => {
  // Use a ref to track if the component has mounted
  const isMountedRef = React.useRef(false);
  
  // Log budget value for debugging
  React.useEffect(() => {
    if (!isMountedRef.current) {
      console.log('BudgetStep mounting with value:', selectedBudget);
      isMountedRef.current = true;
    } else {
      console.log('BudgetStep updating with value:', selectedBudget);
    }
  }, [selectedBudget]);
  
  return (
    <div className={`user-page__form-step-3 ${showThirdStep ? 'third-step-animate' : ''}`}>
      <h2 className="user-page__form-title">Are there any other specifics you need?</h2>
      <div className="user-page__form-row">
        <div 
          className={`form-dropdown user-page__dropdown ${dropdownExpanded ? 'expanded' : ''}`}
        >
          <div 
            className={`form-dropdown__selected ${dropdownExpanded ? 'expanded' : ''}`}
            onClick={() => setDropdownExpanded(!dropdownExpanded)}
          >
            <input
              type="text"
              className="form-dropdown__text-input"
              value={selectedBudget ? (
                typeof selectedBudget === 'string' 
                  ? selectedBudget 
                  : (selectedBudget.label || selectedBudget.value || '')
              ) : ''}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.trim() === '') {
                  setSelectedBudget(null);
                } else {
                  setSelectedBudget({ value: inputValue, label: inputValue });
                }
                setHasUserInput(true);
                localStorage.setItem('zahoot_hasUserInput', 'true');
              }}
              onClick={(e) => e.stopPropagation()}
              style={{
                border: 'none',
                background: 'transparent',
                width: '100%',
                outline: 'none',
                fontSize: '1.05rem',
                fontWeight: '500',
                // color: '#1E1B3F',
                color: '#fff',
                padding: '0',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Search Button Component
export const SearchButton = ({ hasUserInput, handleGlobalSearch }) => {
  if (!hasUserInput) return null;
  
  return (
    <button 
      onClick={handleGlobalSearch}
      className="user-page__global-search-btn"
      >
      Get results 
    </button>
  );
}; 